export default {
    HOME: {
        path: '/',
        name: 'home'
    },
    BROWSING: {
        path: '/browsing',
        name: 'browsing'
    },
    PART_LISTING: {
        path: '/browsing/technology',
        name: 'technology'
    },
    PART_DETAIL: {
        path: '/distributor',
        name: 'distributor'
    },
    EXT_SLEUTH: {
        path: '/search/:query',
        name: 'externalSleuth'
    }
};
